module.exports = __webpack_public_path__ + "static/img/fingerpost_express_3.4fb7959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_3.jpg
// module id = MRb8
// module chunks = 0